import { getUserConfigData } from '@domain/user-config';
import { DEFAULT_FILTER } from '../campaigns-filter.constants';
import { hasRule } from '../rules/rules.utils';
import { NEW_FILTER_NAME } from './filters.constants';
import { Filter } from './filters.types';

export const isNewFilter = ({ value }) => value === NEW_FILTER_NAME;

export const findCustomFilter = ({ customFilters }, { selectedFilter }) => {
    const { value } = selectedFilter;

    return customFilters.find(
        filter => filter.name === value,
    );
};

export const buildSaveNewFilterUserConfig = ({
    userConfigData,
    type,
    id,
    newFilter,
}) => {
    const filters = getUserDataFilters({
        userConfigData,
        type,
        id,
    });

    const { CAMPAIGNS_FILTERS = {} } = userConfigData;

    return {
        configs: {
            CAMPAIGNS_FILTERS: {
                ...(CAMPAIGNS_FILTERS),
                [type]: {
                    ...(CAMPAIGNS_FILTERS[type] || {}),
                    [id]: {
                        ...filters,
                        activeFilter: newFilter,
                        customFilters: [
                            ...(filters?.customFilters || []),
                            newFilter,
                        ],
                    },
                },
            },
        },
    };
};

export const buildUpdateActiveFilterUserConfig = ({
    userConfigData,
    type,
    id,
    selectedFilter,
}) => {
    const filters = getUserDataFilters({
        userConfigData,
        type,
        id,
    });

    const { CAMPAIGNS_FILTERS = {} } = userConfigData;

    return {
        configs: {
            CAMPAIGNS_FILTERS: {
                ...CAMPAIGNS_FILTERS,
                [type]: {
                    ...(CAMPAIGNS_FILTERS[type] || {}),
                    [id]: {
                        ...filters,
                        activeFilter: selectedFilter,
                        customFilters: [
                            ...(filters?.customFilters || []),
                        ],
                    },
                },
            },
        },
    };
};

export const buildUpdateSavedFilterUserConfig = ({
    state,
    type,
    id,
    savedFilter,
}) => {
    const userConfigData = getUserConfigData(state);
    const campaignFiltersState = state.campaigns.campaignsFilters.filters;

    const filters = getUserDataFilters({
        userConfigData,
        type,
        id,
    });

    const { CAMPAIGNS_FILTERS = {} } = userConfigData;

    return {
        configs: {
            CAMPAIGNS_FILTERS: {
                ...CAMPAIGNS_FILTERS,
                [type]: {
                    ...(CAMPAIGNS_FILTERS[type] || {}),
                    [id]: {
                        ...filters,
                        activeFilter: savedFilter,
                        customFilters: getUpdatedCustomFilters({
                            savedFilter, type, id, state: campaignFiltersState,
                        }),
                    },
                },
            },
        },
    };
};

export const isSameFilter = (
    { rules: r1 }: Partial<Filter>,
    { rules: r2 }: Partial<Filter>,
): boolean => (
    r1.length === r2.length
    && r1.every(r1Rule => hasRule(r2, r1Rule))
);

const getUserDataFilters = ({
    userConfigData,
    type,
    id,
}) => {
    const { CAMPAIGNS_FILTERS = {} } = userConfigData;
    const typeFilters = CAMPAIGNS_FILTERS[type];

    return typeFilters ? userConfigData.CAMPAIGNS_FILTERS[type][id] : {};
};

export const getCustomFilters = ({ state, type, id }) => (state[type][id]?.customFilters
    || DEFAULT_FILTER.customFilters);

export const getUpdatedCustomFilters = ({
    state, type, id, savedFilter,
}) => getCustomFilters({ state, type, id }).map(
    filter => (isSameFilter(filter, savedFilter) ? savedFilter : filter),
);
